{
    "page": 1,
    "size": 100,
    "total": 13,
    "total_pages": 1,
    "data": [
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
            "average_balance": 10000,
            "validated": null,
            "average_balance_year": 2026,
            "average_balance_month": 1,
            "income": 2800000,
            "person_id": null,
            "outcome": 3000000,
            "initial_balance": null,
            "final_balance": null,
            "document_id": "ba60846f-2afe-4450-82d2-3ee546354279",
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2026-03-23T23:54:00.028366",
            "id": "0ce53c59-44a4-404a-9e49-b99dd9a06780",
            "credit_validation_catalog": {
                "id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
                "name": "Saldo promedio mes",
                "description": "Extracción de saldos promedio, si hay mas de una cuenta sumar el saldo promedio de todas las cuentas para cada mes:",
                "code": "VCPM",
                "order": 7,
                "credit_validation_type_id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                "credit_validation_type": {
                    "id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                    "name": "Validación de Cuentas",
                    "description": "Validación de Cuentas",
                    "code": "VCVC"
                }
            },
            "document": {
                "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
                "file_category_id": "c83f8b41-4cd8-4eee-90c3-74851b716a09",
                "client_details_id": "6b75bbf4-afa9-42d1-a70d-84e903d8a3b9",
                "person_id": null,
                "file_name": "EdoCuenta1.pdf",
                "url": "ExpedienteCliente/pfae/6b75bbf4-afa9-42d1-a70d-84e903d8a3b9/bf40efb3-a688-4972-8335-d3e1c7c00c4b/c83f8b41-4cd8-4eee-90c3-74851b716a09_8773b415-0982-4257-a5e0-e6d2a84ada95.pdf",
                "status": true,
                "validated": null,
                "sign_client": null,
                "sign_user": null,
                "sign_validated": null,
                "guarantee_id": null
            }
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
            "average_balance": 1500000,
            "validated": null,
            "average_balance_year": 2025,
            "average_balance_month": 7,
            "income": 3000000,
            "person_id": null,
            "outcome": 1000000,
            "initial_balance": null,
            "final_balance": null,
            "document_id": "7401b6e5-e9df-477c-81d7-5ab55d0ccaeb",
            "created_at": "2026-01-15T11:26:42.189199",
            "updated_at": "2026-03-23T23:54:00.028366",
            "id": "10899250-4221-49c2-80dd-3ba9a6c93afd",
            "credit_validation_catalog": {
                "id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
                "name": "Saldo promedio mes",
                "description": "Extracción de saldos promedio, si hay mas de una cuenta sumar el saldo promedio de todas las cuentas para cada mes:",
                "code": "VCPM",
                "order": 7,
                "credit_validation_type_id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                "credit_validation_type": {
                    "id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                    "name": "Validación de Cuentas",
                    "description": "Validación de Cuentas",
                    "code": "VCVC"
                }
            },
            "document": {
                "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
                "file_category_id": "c83f8b41-4cd8-4eee-90c3-74851b716a09",
                "client_details_id": "6b75bbf4-afa9-42d1-a70d-84e903d8a3b9",
                "person_id": null,
                "file_name": "Doc_de_Prueba_3.pdf",
                "url": "ExpedienteCliente/pfae/6b75bbf4-afa9-42d1-a70d-84e903d8a3b9/bf40efb3-a688-4972-8335-d3e1c7c00c4b/c83f8b41-4cd8-4eee-90c3-74851b716a09_2d3f8793-5577-4c87-b0f4-438b54c266e0.pdf",
                "status": true,
                "validated": true,
                "sign_client": null,
                "sign_user": null,
                "sign_validated": null,
                "guarantee_id": null
            }
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "772c9c57-0942-4af7-9b7d-ca0303584122",
            "average_balance": null,
            "validated": null,
            "average_balance_year": null,
            "average_balance_month": null,
            "income": null,
            "person_id": null,
            "outcome": null,
            "initial_balance": null,
            "final_balance": null,
            "document_id": null,
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2025-10-03T00:15:50.039286",
            "id": "16048d4a-622b-48d0-a2bb-ab354cb9a0e9",
            "credit_validation_catalog": {
                "id": "772c9c57-0942-4af7-9b7d-ca0303584122",
                "name": "Productos en actividad económica",
                "description": "Los productos comprados y vendidos están en línea con la actividad y giro.",
                "code": "VCPAE",
                "order": 2,
                "credit_validation_type_id": "e5382648-59a8-482f-b12b-8dd9f5c047e3",
                "credit_validation_type": {
                    "id": "e5382648-59a8-482f-b12b-8dd9f5c047e3",
                    "name": "Actividad",
                    "description": "Actividad",
                    "code": "VCAA"
                }
            },
            "document": null
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "9ac58084-aea1-47d0-b695-019e06039ca2",
            "average_balance": null,
            "validated": null,
            "average_balance_year": null,
            "average_balance_month": null,
            "income": null,
            "person_id": null,
            "outcome": null,
            "initial_balance": null,
            "final_balance": null,
            "document_id": null,
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2025-10-03T00:15:50.039286",
            "id": "1996c6e0-dbdb-4ca0-a904-fa9ddbd8ff02",
            "credit_validation_catalog": {
                "id": "9ac58084-aea1-47d0-b695-019e06039ca2",
                "name": "Coincidencia giro y actividad económica",
                "description": "El giro proporcionado en la solicitud, así como las actividades registradas ante el SAT coinciden.",
                "code": "VCACE",
                "order": 1,
                "credit_validation_type_id": "e5382648-59a8-482f-b12b-8dd9f5c047e3",
                "credit_validation_type": {
                    "id": "e5382648-59a8-482f-b12b-8dd9f5c047e3",
                    "name": "Actividad",
                    "description": "Actividad",
                    "code": "VCAA"
                }
            },
            "document": null
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
            "average_balance": 1200000,
            "validated": null,
            "average_balance_year": 2025,
            "average_balance_month": 12,
            "income": 1500000,
            "person_id": null,
            "outcome": 1300000,
            "initial_balance": null,
            "final_balance": null,
            "document_id": "c97637dd-ae93-4cd1-bb42-713a3a930e8f",
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2026-03-23T23:54:00.028366",
            "id": "23dc1485-538e-4c83-8ad2-e07f88408764",
            "credit_validation_catalog": {
                "id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
                "name": "Saldo promedio mes",
                "description": "Extracción de saldos promedio, si hay mas de una cuenta sumar el saldo promedio de todas las cuentas para cada mes:",
                "code": "VCPM",
                "order": 7,
                "credit_validation_type_id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                "credit_validation_type": {
                    "id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                    "name": "Validación de Cuentas",
                    "description": "Validación de Cuentas",
                    "code": "VCVC"
                }
            },
            "document": {
                "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
                "file_category_id": "c83f8b41-4cd8-4eee-90c3-74851b716a09",
                "client_details_id": "6b75bbf4-afa9-42d1-a70d-84e903d8a3b9",
                "person_id": null,
                "file_name": "Doc de Prueba-4.pdf",
                "url": "ExpedienteCliente/pfae/6b75bbf4-afa9-42d1-a70d-84e903d8a3b9/bf40efb3-a688-4972-8335-d3e1c7c00c4b/c83f8b41-4cd8-4eee-90c3-74851b716a09_15e5e426-6efc-45e0-9dda-d80a3ce1b63d.pdf",
                "status": true,
                "validated": null,
                "sign_client": null,
                "sign_user": null,
                "sign_validated": null,
                "guarantee_id": null
            }
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
            "average_balance": 1400,
            "validated": null,
            "average_balance_year": 2025,
            "average_balance_month": 12,
            "income": 1200000,
            "person_id": null,
            "outcome": 1800000,
            "initial_balance": null,
            "final_balance": null,
            "document_id": "0e5bfe6c-f880-4afb-b5fb-db83b195a909",
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2026-01-14T20:40:13.718838",
            "id": "53df65a2-ce63-40be-892f-49662bb2e92f",
            "credit_validation_catalog": {
                "id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
                "name": "Saldo promedio mes",
                "description": "Extracción de saldos promedio, si hay mas de una cuenta sumar el saldo promedio de todas las cuentas para cada mes:",
                "code": "VCPM",
                "order": 7,
                "credit_validation_type_id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                "credit_validation_type": {
                    "id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                    "name": "Validación de Cuentas",
                    "description": "Validación de Cuentas",
                    "code": "VCVC"
                }
            },
            "document": {
                "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
                "file_category_id": "c83f8b41-4cd8-4eee-90c3-74851b716a09",
                "client_details_id": "6b75bbf4-afa9-42d1-a70d-84e903d8a3b9",
                "person_id": null,
                "file_name": "Doc_de_Prueba_2.pdf",
                "url": "ExpedienteCliente/pfae/6b75bbf4-afa9-42d1-a70d-84e903d8a3b9/bf40efb3-a688-4972-8335-d3e1c7c00c4b/c83f8b41-4cd8-4eee-90c3-74851b716a09_db330e00-3b67-4f98-ab32-3c79dd30aa97.pdf",
                "status": true,
                "validated": null,
                "sign_client": null,
                "sign_user": null,
                "sign_validated": null,
                "guarantee_id": null
            }
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "da2b63a2-05b2-4b50-b823-3268169e4c30",
            "average_balance": null,
            "validated": null,
            "average_balance_year": null,
            "average_balance_month": null,
            "income": null,
            "person_id": null,
            "outcome": null,
            "initial_balance": null,
            "final_balance": null,
            "document_id": null,
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2025-10-03T00:15:50.039286",
            "id": "76a736d9-175f-42ce-9cc8-8402ae28bec8",
            "credit_validation_catalog": {
                "id": "da2b63a2-05b2-4b50-b823-3268169e4c30",
                "name": "Ningua actividad restringida",
                "description": "Ninguna de las actividades registradas ni la proporcionada por el cliente son una actividad restringida.",
                "code": "VCNAR",
                "order": 3,
                "credit_validation_type_id": "e5382648-59a8-482f-b12b-8dd9f5c047e3",
                "credit_validation_type": {
                    "id": "e5382648-59a8-482f-b12b-8dd9f5c047e3",
                    "name": "Actividad",
                    "description": "Actividad",
                    "code": "VCAA"
                }
            },
            "document": null
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
            "average_balance": 300000,
            "validated": null,
            "average_balance_year": 2026,
            "average_balance_month": 1,
            "income": 400000,
            "person_id": null,
            "outcome": 350000,
            "initial_balance": null,
            "final_balance": null,
            "document_id": "66882a91-e5b4-4ba2-8d45-b125434ec4a0",
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2026-03-23T23:54:00.028366",
            "id": "771fee12-ad2d-4d12-9f75-a2051e3363e1",
            "credit_validation_catalog": {
                "id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
                "name": "Saldo promedio mes",
                "description": "Extracción de saldos promedio, si hay mas de una cuenta sumar el saldo promedio de todas las cuentas para cada mes:",
                "code": "VCPM",
                "order": 7,
                "credit_validation_type_id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                "credit_validation_type": {
                    "id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                    "name": "Validación de Cuentas",
                    "description": "Validación de Cuentas",
                    "code": "VCVC"
                }
            },
            "document": {
                "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
                "file_category_id": "c83f8b41-4cd8-4eee-90c3-74851b716a09",
                "client_details_id": "6b75bbf4-afa9-42d1-a70d-84e903d8a3b9",
                "person_id": null,
                "file_name": "Doc de Prueba-3.pdf",
                "url": "ExpedienteCliente/pfae/6b75bbf4-afa9-42d1-a70d-84e903d8a3b9/bf40efb3-a688-4972-8335-d3e1c7c00c4b/c83f8b41-4cd8-4eee-90c3-74851b716a09_c27622ce-1f55-441f-8ff6-58bc92c72c53.pdf",
                "status": true,
                "validated": null,
                "sign_client": null,
                "sign_user": null,
                "sign_validated": null,
                "guarantee_id": null
            }
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "af47a205-b71d-40c8-bd62-baba6522f9a6",
            "average_balance": null,
            "validated": null,
            "average_balance_year": null,
            "average_balance_month": null,
            "income": null,
            "person_id": null,
            "outcome": null,
            "initial_balance": null,
            "final_balance": null,
            "document_id": null,
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2025-10-03T00:15:50.039286",
            "id": "a6b5dc34-a010-449f-8ef4-ca06e343bf7f",
            "credit_validation_catalog": {
                "id": "af47a205-b71d-40c8-bd62-baba6522f9a6",
                "name": "Ingreso promedio mensual SAT",
                "description": "Representa el promedio de sus saldos sus ingresos mensuales ante el SAT.",
                "code": "VCIPM",
                "order": 9,
                "credit_validation_type_id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                "credit_validation_type": {
                    "id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                    "name": "Validación de Cuentas",
                    "description": "Validación de Cuentas",
                    "code": "VCVC"
                }
            },
            "document": null
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
            "average_balance": 200000,
            "validated": null,
            "average_balance_year": 2025,
            "average_balance_month": 11,
            "income": 2000000,
            "person_id": null,
            "outcome": 2000000,
            "initial_balance": null,
            "final_balance": null,
            "document_id": "d4a0fa0b-d76d-4e28-9cd6-210b693b14ab",
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2026-03-23T23:54:00.028366",
            "id": "b58b0e5b-9a53-4488-8ac6-3d54cd9c8695",
            "credit_validation_catalog": {
                "id": "fd6d5654-a340-4200-b8a6-4f6c3a01d601",
                "name": "Saldo promedio mes",
                "description": "Extracción de saldos promedio, si hay mas de una cuenta sumar el saldo promedio de todas las cuentas para cada mes:",
                "code": "VCPM",
                "order": 7,
                "credit_validation_type_id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                "credit_validation_type": {
                    "id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                    "name": "Validación de Cuentas",
                    "description": "Validación de Cuentas",
                    "code": "VCVC"
                }
            },
            "document": {
                "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
                "file_category_id": "c83f8b41-4cd8-4eee-90c3-74851b716a09",
                "client_details_id": "6b75bbf4-afa9-42d1-a70d-84e903d8a3b9",
                "person_id": null,
                "file_name": "EdoCuenta3.pdf",
                "url": "ExpedienteCliente/pfae/6b75bbf4-afa9-42d1-a70d-84e903d8a3b9/bf40efb3-a688-4972-8335-d3e1c7c00c4b/c83f8b41-4cd8-4eee-90c3-74851b716a09_694df631-fa90-4358-afad-0890bdc598f6.pdf",
                "status": true,
                "validated": null,
                "sign_client": null,
                "sign_user": null,
                "sign_validated": null,
                "guarantee_id": null
            }
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "6dd45dfa-c24f-48c5-be1f-addb309da6ec",
            "average_balance": null,
            "validated": null,
            "average_balance_year": null,
            "average_balance_month": null,
            "income": null,
            "person_id": null,
            "outcome": null,
            "initial_balance": null,
            "final_balance": null,
            "document_id": null,
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2025-10-03T00:15:50.039286",
            "id": "c68ef9e8-2339-42f6-981a-f50c79a2cefb",
            "credit_validation_catalog": {
                "id": "6dd45dfa-c24f-48c5-be1f-addb309da6ec",
                "name": "Índice de Volatilidad",
                "description": "Índice de Volatilidad de saldo promedio en cuentas bancarias  =",
                "code": "VCIV",
                "order": 8,
                "credit_validation_type_id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                "credit_validation_type": {
                    "id": "22030cdb-a393-4737-ab73-d2d15309f78a",
                    "name": "Validación de Cuentas",
                    "description": "Validación de Cuentas",
                    "code": "VCVC"
                }
            },
            "document": null
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "c7ce2a4f-6424-4b62-b2ff-2f4347ba1ae7",
            "average_balance": null,
            "validated": null,
            "average_balance_year": null,
            "average_balance_month": null,
            "income": null,
            "person_id": null,
            "outcome": null,
            "initial_balance": null,
            "final_balance": null,
            "document_id": null,
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2025-10-03T00:15:50.039286",
            "id": "d67ca589-449a-49d9-94fb-5c602c00d3e1",
            "credit_validation_catalog": {
                "id": "c7ce2a4f-6424-4b62-b2ff-2f4347ba1ae7",
                "name": "Búro Empresa",
                "description": "Empresa - Revisión de comportamiento de pago de créditos activos y cerrados",
                "code": "VCBE",
                "order": 1,
                "credit_validation_type_id": "13f09dd0-9350-470d-a29e-c945dc396e1c",
                "credit_validation_type": {
                    "id": "13f09dd0-9350-470d-a29e-c945dc396e1c",
                    "name": "Burós",
                    "description": "Burós",
                    "code": "VCBU"
                }
            },
            "document": null
        },
        {
            "loan_application_id": "bf40efb3-a688-4972-8335-d3e1c7c00c4b",
            "credit_validation_id": "f559ae5b-2409-4e57-8c28-afafcddd3a05",
            "average_balance": null,
            "validated": null,
            "average_balance_year": null,
            "average_balance_month": null,
            "income": null,
            "person_id": null,
            "outcome": null,
            "initial_balance": null,
            "final_balance": null,
            "document_id": null,
            "created_at": "2025-10-03T00:15:50.039225",
            "updated_at": "2025-10-03T00:15:50.039286",
            "id": "ded60388-41c3-481c-806a-9376220ef297",
            "credit_validation_catalog": {
                "id": "f559ae5b-2409-4e57-8c28-afafcddd3a05",
                "name": "Búro Persona",
                "description": "Persona - Revisión de comportamiento de pago de créditos activos y cerrados",
                "code": "VCBP",
                "order": 2,
                "credit_validation_type_id": "13f09dd0-9350-470d-a29e-c945dc396e1c",
                "credit_validation_type": {
                    "id": "13f09dd0-9350-470d-a29e-c945dc396e1c",
                    "name": "Burós",
                    "description": "Burós",
                    "code": "VCBU"
                }
            },
            "document": null
        }
    ]
}
